import React from 'react'
import styled from 'styled-components'

/**
 *
 * @param {object} props
 * @param {any} props.children
 * @param {string} props.to
 * @param {string=} props.className
 * @param {any=} props.as A component used to render this link with
 * @param {Object=} props.props Props passed from Semantic UI Popup
 */
export function NewTabLink({ children, to, className, as, ...props }) {
  return (
    <A target="_blank" rel="noopener" href={to} className={className} as={as} {...props}>
      {children}
    </A>
  )
}

const A = styled.a`
  color: inherit;

  &.grey {
    color: #9b9b9b;
  }

  &:hover {
    color: #1e70bf;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/NewTabLink/index.js